var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.$t('component.siteLastUpdate.lastUpdate'))+" "+_vm._s(_vm.$dateTime(_vm.thing.lastUpdate) || '-'))])}
var staticRenderFns = []

export { render, staticRenderFns }